<template>
	<el-container class="course_sele">
        <div class="con">
            <div class="live">
			    <div class="titBox" v-if="login">
			    	<p class="tit">选课
			    	</p>
                    <div class="select_number">
                        请选择
                        <span>{{select_number}}</span>
                        门课程
                    </div>
			    </div>
                <div class="course_selection">
                    <div class="course_selection_l" v-if="login">
                        <div class="course_selection_hed">已选课程</div>
                        <div v-for="cou_item,cou_key in selected_courses_data" :key="'cou'+cou_key">
                            <div v-if="cou_item.list.length">
                                <div class="selected_course_mould">
                                    {{cou_item.name}}
                                </div>
                                <div class="selected_course" v-for="(maj_item,maj_i) in cou_item.list" :key="maj_i">
                                    <div class="selected_course_hed">
                                        <span>{{maj_item.course_name}}</span>
                                        <span class="red" @click="cou_red(cou_key,maj_i)">删除</span>
                                    </div>
                                    <div class="selected_course_data">学期：{{maj_item.term?'第'+$selfjs.qiZh(maj_item.term)+'学期':' - '}} </div>
                                </div>
                                <div class="set_data">
                                    <span>已选 <span style="color:#2991e1;">{{cou_item.list.length}}</span>门课</span>
                                    <!-- <span>合计 <span style="color:#2991e1;">{{study_hour_sum(cou_key)}}</span> 学时</span> -->
                                </div>
                            </div>
                            
                        </div>
                        <div class="btn">
                            <el-button size="mini" type="primary" v-if="sou_study_sum!=0" @click="submit">保存选课方案</el-button>
                        </div>
                    </div>
                    <div class="course_selection_r">
                        <ul class="zui" v-if="course_list.length">
			            	<li v-for="(item,i) in course_list" :key="i">
			            		<div class="coverbox">
			            			<div class="course_type" >{{item.course_type_format}}</div>
			            			<div class="courseImgContent">{{item.course_name}}</div>
			            		</div>
			            		<div class="courseTitBox" style="height: 60px;">
                                    <p class="tit">{{item.course_name}}</p>
                                    <p>学期：{{item.term?'第'+$selfjs.qiZh(item.term)+'学期':' - '}}</p>
                                    <el-button type="primary" size="mini" @click="selected(item)" v-if="login&&item.is_selected==2">选课</el-button>
                                    <el-button type="info" size="mini" v-if="login&&item.is_selected==1">已选</el-button>
                                </div>
			            	</li>
			            </ul>
                        <div class="nodata" v-else style="height: 360px;">
			            	<img style="width: 300px;" :src="global.oss_website+'/wap/images/no_data_img.jpg'">
			            	<p>专业暂无课程</p>
			            </div>
                        <el-pagination
                          v-if="course_list.length"
                          background
                          @current-change="handleCurrentChange"
                          layout="prev, pager, next"
                          :current-page="params.page"
    		              :page-size="params.limit"
                          :total="params.total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </el-container>
</template>
<script>
export default {
	name: 'course_sele'
    ,components:{
    }
	,data () {
		return {
            class_show:0,
            options_id:{},
            options_data:[],
            subdivision_options:{
                children:[],
                name:'',
            },
            params:{
				page:1,
				limit:8,
                total:0
			},
            course_list:[],
            selected_courses_data:{},
            sou_study_sum:0,
            login:false,
            select_number:0,
		}
	}
	,mounted:function(){
        if (this.$cookies.get("token")) {
            this.login = true
            this.params.limit = 6
        }
        this.$store.dispatch('get_identity_list').then(res=>{
			// console.log(res);
			if (res.length>=1) {
                this.user_course_my()
			}
		})
        this.$ajax.get(
			this.global.serverSrc + this.global.qianzui + '/user_course/restrict'
		)
		.then((res)=>{
            let resData = res.data
			if(resData.code==0){
                this.select_number = resData.data.max_select_course_count
            } 
		})
        this.user_course()
	}
	,watch:{
	}
	,computed:{
        study_hour_sum(){
            return (key)=>{
                let sum = 0
                this.selected_courses_data[key].list.map((v)=>{
                    sum+=parseInt(v.study_hour)
                })
                return sum
            }
        },
        
	}
	,methods:{
        //点击选课
        selected(item){
            if (this.sou_study_sum>=this.select_number) {
                this.$message.warning('选课超出限制，请删除课程再进行选择');
                return false
            }
            if (this.selected_courses_data[item.mould_id]) {
                this.selected_courses_data[item.mould_id].name = item.major_name
                if (!this.selected_courses_data[item.mould_id].list.some(v=>{ return v.course_id==item.course_id })) {
                    this.selected_courses_data[item.mould_id].list.push(item)
                }
            }else{
                this.selected_courses_data[item.mould_id] = {
                    name:item.major_name,
                    list:[item]
                }
            }
            item.is_selected = 1
            this.sou_study_sum_fn()
            this.course_determine()
            this.$forceUpdate();
        },
        //请求课程列表
        user_course(){
            let that = this
            const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
            this.$ajax.get(
		    	this.global.serverSrc + this.global.qianzui + '/user_course',{
		        	params: {...that.options_id,...that.params}
		        }
		    )
		    .then(function (res){
                // console.log(res);
                loading.close()
		    	let resData = res.data
		    	if(resData.code==0){
                    that.course_list = resData.data.data
                    that.params.total = resData.data.total
                    that.course_determine()
		    	}
		    }).catch(_ => {
                loading.close()
				that.$alert('选课列表异常', '信息提示', {
					confirmButtonText: '确定',
				});
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
        },
        //请求已选课程
        user_course_my(){
            if (!this.login) {
                return false
            }
            let that = this
            this.$ajax.get(
		    	this.global.serverSrc + this.global.qianzui + '/user_course/my'
		    )
		    .then(function (res){
                let resData = res.data
		    	if(resData.code==0){
                    for (let i = 0; i < resData.data.length; i++) {
                        let sele_data = resData.data[i]
                        that.selected_courses_data[sele_data.mould_id] = {
                            name:sele_data.name,
                            list:sele_data.courses
                        }
                    }
                    that.sou_study_sum_fn()
                    that.course_determine()
                    that.$forceUpdate();
                }
                
		    })
        },
        handleCurrentChange(data){
            this.params.page = data
            this.user_course()
        },
        //删除课程
        cou_red(key,i){
            this.selected_courses_data[key].list.splice(i,1)
            this.sou_study_sum_fn()
            this.course_determine()
            this.$forceUpdate();
        },
        //课程总数
        sou_study_sum_fn(){
            this.sou_study_sum = 0
            for (const key in this.selected_courses_data) {
                this.selected_courses_data[key].list.map((v)=>{
                    // this.sou_study_sum+=parseInt(v.study_hour)
                    this.sou_study_sum++
                })
            }
        },
        //保存已选课程
        submit(){
            let data = []
            let that = this
            for (const key in this.selected_courses_data) {
                for (let i = 0; i < this.selected_courses_data[key].list.length; i++) {
                    let obj = this.selected_courses_data[key].list[i]
                    data.push({
                        mould_id:obj.mould_id,
                        course_id:obj.course_id,
                        user_course_id:obj.user_course_id,
                    })
                }
            }
            if (data.length===0) {
                this.$message.error('请选择课程！');
                return false
            }
            const loading = this.$loading({
        	  	lock: true,
        	  	text: 'Loading',
        	  	spinner: 'el-icon-loading',
        	  	background: 'rgba(0, 0, 0, 0.7)'
        	});
            this.$ajax.post(
		    	this.global.serverSrc + this.global.qianzui + '/user_course/submit',
                this.$qs.stringify({selected:data})
		    ).then(function (res){
                loading.close()
		    	let resData = res.data
		    	if(resData.code==0){
                    that.$message.success('操作成功！');
                    window.location.reload()
		    	}
		    }).catch(_ => {
                loading.close()
				that.$alert('选课列表异常', '信息提示', {
					confirmButtonText: '确定',
				});
				// this.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~')
			});
        },
        //判断选课
        course_determine(){
            

            let sel_arr = []
            for (const key in this.selected_courses_data) {
                for (let i = 0; i < this.selected_courses_data[key].list.length; i++) {
                    let obj = this.selected_courses_data[key].list[i]
                    // console.log(obj.course_id);
                    sel_arr.push(obj.course_id)
                }
            }
            // this.course_list.map(v=>{
            //     console.log(v.course_id);
            //     if (obj.course_id==v.course_id) {
            //         v.is_selected = 1
            //     }else{
            //         v.is_selected = 2
            //     }
            // })
            this.course_list.map(v=>{
                if(sel_arr.indexOf(v.course_id)!=-1){
                    v.is_selected = 1
                }else{
                    v.is_selected = 2
                }
            })
            
            console.log(this.course_list);
        }
	}
	,destroyed:function(){
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/renwu/course_selection_center.vue